const ModuleIdentifierConst = {
  ORGANISATION: 'organizationManagement',
  ATTRIBUTE: 'userAttributeManagement',
  ROLE: 'roleManagement',
  USER: 'user',
  PERMISSION: 'permissionsManagement',
  INCENTIVE: 'incentiveManagement',
  COMMUNICATION: 'templateManagement',
  NUDGE_CONFIGURATION: 'nudgeConfigurationManagement',
  AUDIENCE_GROUPING: 'audienceGroupManagement',
};

export default ModuleIdentifierConst;
